function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import './Loader.css';
export var Loader = function Loader(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'light' : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  var className = "dib la-ball-triangle-path la-".concat(color, " la-sm");
  return /*#__PURE__*/React.createElement("div", props, /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      width: 20,
      height: 20
    }
  }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null)));
};